import { type FC, type ReactNode } from "react";
import { useSelector } from "react-redux";
import { selectIsInFlight, selectSearchQuery } from "~/Search/redux/searchSelectors";
import { PackageRestrictionContext } from "~/common/components/PackageRestrictionContext/PackageRestrictionContext";
import { useCalculateRestrictedCode } from "~/common/components/PackageRestrictionContext/useCalculateRestrictedCode";

interface Props {
  productCode: string;
  children?: ReactNode;
}
export const SRPPackageRestrictionContext: FC<Props> = ({ productCode, children }) => {
  const query = useSelector(selectSearchQuery);
  const isInFlight = useSelector(selectIsInFlight);
  const restrictedCode = useCalculateRestrictedCode(isInFlight ? "" : query, productCode);

  return <PackageRestrictionContext value={restrictedCode}>{children}</PackageRestrictionContext>;
};
